import Vue from 'vue';
import CheckoutView from './CheckoutView/CheckoutView.vue';
import {INIT_BUYER_DATA, INIT_CART, INIT_IS_GUEST_ORDER, INIT_USER} from '../../store/commits';
import {Store} from 'vuex';
import {RootState} from '../../store';

export class Checkout {
  constructor(appElement: HTMLElement, dataElement: any, store: Store<RootState>, i18n) {
    // @ts-ignore
    new Vue({
      el: appElement,
      template: `
        <checkout-view
          payment-methods="${appElement.dataset.paymentMethods}"
          success-url="${appElement.dataset.checkoutDoneUrl}"
          cancel-url="${appElement.dataset.checkoutCancelUrl}"
          failure-url="${appElement.dataset.checkoutFailureUrl}"
          ticket-shop-url="${dataElement.ticketShopPage}"
          login-url="${dataElement.login}"
          login-page-url="${dataElement.loginPage}"
          inventory-url="${dataElement.inventory}"/>`,
      components: {CheckoutView},
      store,
      // @ts-ignore
      i18n,
      beforeCreate() {
        this.$store.commit(INIT_IS_GUEST_ORDER);
        this.$store.commit(INIT_USER);
        this.$store.commit(INIT_BUYER_DATA);
      },
    });
  }
}
